import { Language } from './language';

export const Polish: Language = {
    loadingDescription: 'Ładowanie szablonów...',
    addToCart: 'DODAJ DO KOSZYKA',
    undo: 'Cofnij',
    toggleFronts: 'Pokaż/ukryj fronty',
    removeElement: 'Usuń element',
};
